// BASED ON
/*! videojs-progressTips - v0.1.0 - 2013-09-16
* https://github.com/mickey/videojs-progressTips
* Copyright (c) 2013 Michael Bensoussan; Licensed MIT */
// MODIFIED BY Fernando Neira - 2015
/* Added thumbnails support and style changes */

(function() {

	videojs.plugin('progressTips', function(options) {
		var init;
		init = function() {
			var player;
			player = this;
			var thumbnailsData;
		
			$.getJSON(options.thumbnailsUrl, function( data ) {
				if(options.debug) window.console && console.log("Obtained thumbnails for media: " + data.imageCount);
				thumbnailsData = data;
			});
			
			$(".vjs-progress-control").after($("      <div id='vjs-tip'>      <div id='vjs-tip-arrow'></div>      <div id='vjs-tip-inner'></div>      </div>    "));
			$(".vjs-progress-control").bind("mousemove", function(event) {
				var minutes, seconds, seekBar, timeInSeconds;
				seekBar = player.controlBar.progressControl.seekBar;
				var mousePosition = (event.pageX - $(seekBar.el()).offset().left) / seekBar.width();
				timeInSeconds = mousePosition * player.duration();
				if (timeInSeconds === player.duration()) {
					timeInSeconds = timeInSeconds - 0.1;
				}
				minutes = Math.floor(timeInSeconds / 60);
				seconds = Math.floor(timeInSeconds - minutes * 60);
				if (seconds < 10) {
					seconds = "0" + seconds;
				}
				
				var tooltipContent = minutes + ":" + seconds;
				
				if(thumbnailsData) {
					var thumbnailPosition = Math.floor( timeInSeconds / (player.duration() / thumbnailsData.imageCount));
					if(options.debug) window.console && console.log("Thumbnail used for tooltip: " + thumbnailPosition);
					var thumbnail = thumbnailsData.thumbnails[thumbnailPosition];
					tooltipContent = "<img class=\"vjs-tip-thumbnail\" src=\"" + thumbnail + "\">" + tooltipContent;
				}
				
				$(".video-js").addClass("vjs-tip-active");        
				$('#vjs-tip-inner').html(tooltipContent);
				$("#vjs-tip").css("left", "" + (event.pageX - $(this).offset().left) + "px").addClass("active");
				return;
			});
			$(".vjs-progress-control, .vjs-play-control").bind("mouseout", function() {
				$("#vjs-tip").removeClass("active");
				$(".video-js").removeClass("vjs-tip-active");        
			});
		};
		this.on("loadedmetadata", init);
	});

}).call(this);
